import { Link } from "react-router-dom";

type Crumb = {
  label: string;
  to?: string;
};

export default function Breadcrumb({ items }: { items: Crumb[] }) {
  return (
    <nav aria-label="面包屑导航" className="flex flex-wrap items-center gap-2 text-xs text-foreground-500">
      <Link to="/" className="flex items-center gap-1 transition-colors hover:text-accent-500">
        <i className="ri-home-5-line" />
        首页
      </Link>
      {items.map((item) => (
        <span key={item.label} className="flex items-center gap-2">
          <i className="ri-arrow-right-s-line" />
          {item.to ? (
            <Link to={item.to} className="transition-colors hover:text-accent-500">
              {item.label}
            </Link>
          ) : (
            <span className="text-foreground-800">{item.label}</span>
          )}
        </span>
      ))}
    </nav>
  );
}